export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M19 4a3 3 0 1 1-2.525 4.615l-7.387 3.41 7.389 3.356a3 3 0 1 1-.47 1.434l-8.194-3.721A2.997 2.997 0 0 1 2 12.063a2.998 2.998 0 0 1 5.792-1.09l8.214-3.792A3 3 0 0 1 19 4Zm0 11.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM5 10.562a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM19 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>
</svg>
`;
